ui-cms-tab-group {
  display: block;

  sd-tab-group {
    &.noLine {
      &::part(separation) {
        display: none;
      }

      &::part(scroll-button--start),
      &::part(scroll-button--end) {
        border-bottom: none;
      }

      sd-tab::part(base):hover {
        // stylelint-disable-next-line
        border-bottom: none !important;
      }
    }

    &.centered {
      &::part(tabs) {
        justify-content: center;
      }
    }
  }

  .sd-tab-group--inverted {
    sd-tab::part(base) {
      background-color: white;
    }
  }
}
